import * as _ from 'underscore';

import ACTIONS from '../actions';

const extraWorkTree = (state = {}, action) => {
    switch (action.type) {
        case ACTIONS.CALENDAR_EXTRA_LOAD:
            var days = { ...state };
            for (let i = 0; i < action.extraWork.length; i++) {
                const extra = action.extraWork[i];
                let items = [];
                if (extra.key in days) {
                    items = days[extra.key];
                }
                if (!_.any(items, item => item.id === extra.id)) {
                    items.push(extra);
                }
                days[extra.key] = items;
            }
            return days;
        case ACTIONS.CALENDAR_REMOVE_EXTRA:
            var dayItems = [];
            for (let i = 0; i < state[action.dayKey].length; i++) {
                if (state[action.dayKey][i].pw_id !== action.programWorkoutId) {
                    dayItems.push({ ...state[action.dayKey][i] });
                }
            }
            var newState = { ...state };
            newState[action.dayKey] = dayItems;
            return newState;
        case ACTIONS.CALENDAR_EXTRA_CLEAR:
            return {};
        default:
            return state;
    }
};

export default extraWorkTree;



// WEBPACK FOOTER //
// ./src/state/reducer/calendar/reducer/extraWorkTree.js